import { CreateBeneficiaryState } from '../types/createBeneficiarySliceTypes';

const initialCreateBeneficiarySteps = {
  relationshipInfo: {
    relationshipId: null,
    relationshipName: '',
    relationshipType: '',
  },
  businessDetails: {
    businessName: '',
    representativeFirstName: '',
    representativeLastName: '',
    tin: '',
    documentsDeliveryPreference: '',
    documentsDeliveryPreferenceId: null,
    contingent: null,
    allocation: null,
  },
  personDetails: {
    firstName: '',
    middleName: '',
    lastName: '',
    suffix: '',
    prefix: '',
    prefixId: null,
    gender: '',
    genderId: null,
    ssn: '',
    clientId: '',
    dateOfBirth: null,
    dateOfDeath: null,
    documentsDeliveryPreference: '',
    documentsDeliveryPreferenceId: null,
    maritalStatus: '',
    maritalStatusId: null,
    occupation: '',
    occupationId: null,
    contingent: null,
    allocation: null,
  },
  addressInfo: {
    isPaymentAddress: false,
    isResidenceAddress: false,
    isMailingAddress: false,
    reAttn: '',
    streetAddress: '',
    addressDetails: '',
    city: '',
    state: '',
    zipCode: '',
    country: '',
  },
  contactInfo: {
    contactPreference: '',
    contactPreferenceId: null,
    mobileNumber: '',
    landline: '',
    email: '',
    fax: '',
  },
  paymentInfo: [],
};

export const createBeneficiaryInitialState: CreateBeneficiaryState = {
  createBeneficiaryType: 'auto',
  createBeneficiarySteps: initialCreateBeneficiarySteps,
  userForBeneficiaryCreate: null,
  statuses: {
    isCreateBeneficiaryLoading: false,
  },
};
